import { render } from "./BackToUp.vue?vue&type=template&id=2df40402&ts=true"
import script from "./BackToUp.vue?vue&type=script&lang=ts"
export * from "./BackToUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__